

/**
 * Interactions for selecting a document, including deletion and uploading
 */
export class SelectDocument {
  /**
   * @param documents DOM element of the documents
   * @param upload CSS selector for DOM element of file upload
   */
  constructor(documents, upload) {
    this.documents = documents;
    this.upload = $(upload);

    this.setSelected();

    this.documents.on('change', 'input[type="radio"]', this.setSelected.bind(this));

    $('.radio a.btn', this.documents).on('click', this.removeDocument);
  }

  /**
   * Sets selected state
   */
  setSelected() {
    const selectedDocument = $(':checked', this.documents);
    const tableRequirements = this.upload.closest('.form-group-apply').siblings('.table-requirements');

    $('.radio', this.documents).removeClass('is-selected');
    selectedDocument.closest('.radio').addClass('is-selected');

    const isUpload = SelectDocument.isUpload(selectedDocument);
    this.upload.prop('disabled', !isUpload).closest('.form-group').toggle(isUpload);
    tableRequirements.toggle(isUpload);
  }

  /**
   * Checks if passed object refers to a file or to a new upload
   * @param {object} doc jQuery DOM object
   * @returns {boolean} Whether passed object is an upload field or actual document
   */
  static isUpload(doc) {
    const value = doc.attr('value');
    return (!value || value === '');
  }

  /**
   * Removes document asynchronously
   * @param {object} event Listener event
   */
  removeDocument(event) {
    const removeButton = $(this);
    const id = removeButton.data('id');

    removeButton.addClass('is-loading');

    $.ajax({
      url: `/api/removeCV?docId=${id}`,
      dataType: 'json',
      cache: false
    })
    .done(() => {
      removeButton.closest('.radio').remove();
    })
    .fail(() => {
      removeButton.removeClass('is-loading');
    });
    event.preventDefault();
  }
}
